import { Flex, Spinner } from '@chakra-ui/react'

interface LoadingProps {
  size?: string
  color?: string
}

const Loading = ({ size = 'xl', color = 'blue.500' }: LoadingProps) => {
  return (
    <Flex width="100%" height="100%" justifyContent="center" alignItems="center" py={8}>
      <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color={color} size={size} />
    </Flex>
  )
}

export default Loading
